import React from "react";


export const transaksiMasukTable = (handleGetDetail, handleInsert) => {
    return [
        {
            title: "Kode Anggaran",
            render: rowData => {
                return <span>{rowData.id_anggaran_pemasukan}</span>
            }
        },
        {
            title: "Nama Anggaran",
            render: rowData => {
                return <span>{rowData.nama_anggaran_pemasukan}</span>
            }
        },
        {
            title: "Target",
            render: rowData => {
                return <span>{rowData.target}</span>
            }
        },
        {
            title: "Realisasi",
            render: rowData => {
                return <span>{rowData.realisasi}</span>
            }
        },
        {
            title: "Action",
            render: rowData => {
                return (
                    <>
                       <button 
                            className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleGetDetail(rowData)}
                        >
                        Detail Transaksi
                        </button>
                        <button
                            className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleInsert(rowData)}
                        >
                            Tambah Transaksi
                        </button>
                    </>
                )
            }
        }
    ]
}